import httpClient from 'utils/api.utils';
import config from 'utils/config';
import { getIsPeopleCuesOrg } from './userApi';

const notificationApi = {
  getNotificationById: notificationId =>
    httpClient.get(`/v1/notification/${notificationId}`, {}),
  getNotifications: requestBody =>
    httpClient.get(
      `${getIsPeopleCuesOrg() ? config.blitzApiUrl : ''}/v2/notification`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  markNotificationRead: (notificationId, module) =>
    httpClient.put(
      `${
        getIsPeopleCuesOrg() ? config.blitzApiUrl : ''
      }/v2/notification/${notificationId}`,
      {},
      {},
      getIsPeopleCuesOrg() ? { module } : {},
      getIsPeopleCuesOrg()
    ),

  markAllNotificationReadFrom: requestBody =>
    httpClient.post(
      `${
        getIsPeopleCuesOrg() ? config.blitzApiUrl : ''
      }/v2/notification?from_time=${requestBody}`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getNotificationPreference: () =>
    httpClient.get('/v1/notification/preference'),

  updateNotificationPreference: requestBody =>
    httpClient.put('/v1/notification/preference', requestBody),

  toggleNotificationPreference: requestBody =>
    httpClient.put('/v1/notification/preference/toggle', requestBody),

  updateChannelDndSettings: requestBody =>
    httpClient.put('/v1/notification/preference/dnd', requestBody)
};

export default notificationApi;
